import { AbstractControl } from '@angular/forms';
import { Injectable } from '@angular/core';
import * as moment from 'moment'
import { firestore } from 'firebase';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class ConvertService {

  constructor() { }

  static dateFormat(date: Date) {
    return moment(date).format('D/MM/YYYY');
  }

  static uniqueArray(arrArg) {
    return arrArg.filter((elem, pos, arr) => {
      return arr.indexOf(elem) == pos;
    });
  }

  static getNumber(value: any, getval: any): number {
    if (value === NaN || value === null || value === undefined || value === '') {
      return getval;
    }
    return Number(value);
  }


  static toCapitalize(value) {
    let string = '';
    if (value) string = value.toUpperCase().toString().trim();
    return string;
  }

  static toFloatFixed2(value) {
    if (value === null || value === "" || value === undefined) {
      return 0;
    }
    if (Number(value) === NaN) return 0;
    return Number(value.toFixed(2));
  }

  static toNumber(value) {
    if (value === null || value === "" || value === undefined) {
      return 0;
    }
    if (Number(value) === NaN) return 0;
    return Number(value);
  }

  static numberOnly(sender: any) {
    let numb = sender.match(/\d/g);
    numb = numb.join("");
    return this.toNumber(numb);
  }

  static toYear(date: Date) {
    return moment(date).format('YYYY');
  }

  public toCapitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  public toLoverCase(string) {
    return string.toLoverCase();
  }

  static toNull(value) {
    if (value === null || value === "" || value === undefined) {
      return null;
    }
    return value;
  }

  static toNullInputValue(input: AbstractControl) {
    if (input === undefined || undefined === null) return null;
    const value = input.value;
    if (value === null || value === "" || value === undefined) {
      return null;
    }
    return value;
  }
  static orderBy(data: Array<any>, field: string) {
    return _.orderBy(data, [field])
  }
  static orderByDesc(data: Array<any>, field: string) {
    return _.orderBy(data, [field], ['desc'])
  }
  static toNullInputKey(input: AbstractControl) {
    if (input === undefined || undefined === null) return null;
    const value = input.value;
    if (value === null || value === "" || value === undefined) {
      return null;
    }
    return value.key;
  }


  static yearSuffix() {
    return moment().format('YY').toString();
  }
  static addWeek(interval: number) {
    return moment().add(interval, 'week').toDate()
  }

  static addMonth(interval: number) {
    return moment().add(interval, 'month').toDate()
  }

  static pageKey() {
    return Number(moment().format('YYYYMMDDHHmmss'))
  }

  static pageKeyMs() {
    return Number(moment().format('YYYYMMDDHHmmssSSSS'))
  }

  static toDateKey(date: Date) {
    return Number(moment(date).format('YYYYMMDD'))
  }

  static dateKey() {
    return Number(moment().format('YYYYMMDD'))
  }

  static hourToNumber(time) {
    return Number(moment(time, 'hh:mm a').format('HH').toString() + '.' + moment(time, 'hh:mm a').format('mm').toString());
  }

  static toHour(time) {
    return moment(time, 'hh:mm a').format('hh:mm a')
  }

  static generate_testing_invoiceNo(config) {
    var number = Number(moment().format('YYMMDD').toString() + (config.invoice_shufit + 1).toString());
    return number;
  }

  static generate_puc_id(config) {
    var number = moment().format('YY').toString() + (config.puc_id + 1).toString();
    return number;
  }

  static addDays(interval: number) {
    return moment().add(interval, 'days').toDate()
  }

  static numberToDate(date: number) {
    return moment(date, 'YYYYMMDD').toDate();
  }

}

export function sum(data: Array<any>, field: string) {
  if (!data) return 0;
  return data.reduce((a, b) => a + Number(b[field]), 0)
}

export function sumStock(data: Array<any>, field: string) {
  if (!data || (data && data.length === 0)) return 0;
  return data.reduce((a, b: any) => a + Number(b[field] * b.movementType.factor), 0)
}

// export function formatNumber(num) {
//   return num.toString().replace(/\d(?=(\d{3})+\.)/g, '$&,');
// }

export function pushToArray(snapshot: firestore.QuerySnapshot): Array<any> {
  if (snapshot.empty) return [];
  return snapshot.docs.map(m => ({ ...m.data(), id: m.id }));
}

export function pushToObject(snapshot: firestore.DocumentSnapshot): any {
  if (!snapshot.exists) return null;
  return { ...snapshot.data(), id: snapshot.id }
}

export function removeObjArray(data: Array<any>, key: string): any {
  let value = [];
  if (data && data.length > 0) {
    value = data.filter(m => m.key !== key);
  }
  return value;
}

export function fieldValueArrayObject(value: any, field, batches: Array<any>) {
  let result: Array<any> = batches;
  if (batches && batches.length > 0) {
    const { key } = value
    const invalid = batches.filter(m => m[field] === key).length === 0;
    if (invalid) result.push(value);
  }
  else {
    result = [];
    result.push(value);
  }
  return result;
}

export function fieldValueArray(key: any, batches: Array<any>) {
  let result: Array<any> = batches;
  if (batches && batches.length > 0) {
    const invalid = batches.filter(m => m === key).length === 0;
    if (invalid) result.push(key);
  }
  else {
    result = [];
    result.push(key);
  }
  return result;
}


export function removeStingArray(data: Array<any>, key: string): any {
  let value = [];
  if (data && data.length > 0) {
    value = data.filter(m => m !== key);
  }
  return value;
}

export function pushObjArray(data: Array<any>, newItem: any, field: any = "key") {
  let value = [];
  if (data && data.length > 0) {
    value = data;
    const exist = value.filter(m => m[field] === newItem.key);
    if (exist && exist.length > 0) {
      const index = value.findIndex((obj => obj[field] == newItem.key));
      value[index] = newItem;
    } else {
      value.push(newItem);
    }
  } else {
    value.push(newItem);
  }

  return value;
}

export function pushStringArray(data: Array<any>, key: string) {
  let value = [];
  if (data && data.length > 0) {
    value = data;
    const exist = value.filter(m => m === key);
    if (exist && exist.length > 0) {
      const index = value.findIndex((obj => obj == key));
      value[index] = key;
    } else {
      value.push(key);
    }
  } else {
    value.push(key);
  }

  return value;
}
export function orderBy(rows: Array<any>, field: string, ascDesc: string = "asc") {
  return _.orderBy(rows, [field], ascDesc)
}


export function orderByData(rows: Array<any>, field: string, ascDesc: string = "asc") {
  return _.orderBy(rows, [field], ascDesc)
}

export function toNumber(value) {
  if (value === null || value === "" || value === undefined) {
    return 0;
  }
  if (Number(value) === NaN) return 0;
  return Number(value);
}

